import { BookingCalendarTypes, BookingCalendarState } from './actionTypes';

export const INIT_STATE: BookingCalendarState = {
  events: [],
  categories: [],
  error: {},
};

const BookingCalendar = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case BookingCalendarTypes.API_SUCCESS:
      switch (action.payload.actionType) {
        case BookingCalendarTypes.GET_EVENTS:
          return {
            ...state,
            events: action.payload.data,
          };

        case BookingCalendarTypes.ADD_NEW_EVENT:
          return {
            ...state,
            events: [...state.events, action.payload.data],
          };

        default:
          return { ...state };
      }
    case BookingCalendarTypes.API_FAIL:
      switch (action.payload.actionType) {
        case BookingCalendarTypes.GET_EVENTS:
          return {
            ...state,
            events: action.payload.error,
          };

        case BookingCalendarTypes.ADD_NEW_EVENT:
          return {
            ...state,
            events: action.payload.error,
          };

        default:
          return { ...state };
      }
    case BookingCalendarTypes.UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.map((event) =>
          event.id.toString() === action.payload.id.toString()
            ? { event, ...action.payload }
            : event
        ),
        isEventUpdated: true,
      };

    case BookingCalendarTypes.UPDATE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case BookingCalendarTypes.DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.filter(
          (event) => event.id.toString() !== action.payload.toString()
        ),
      };

    case BookingCalendarTypes.DELETE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case BookingCalendarTypes.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
      };

    case BookingCalendarTypes.GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case BookingCalendarTypes.RESET_CALENDAR: {
      const flag = action.payload.flag;
      const value = action.payload.value;
      const flags: any = {};
      flags[flag] = value;
      return {
        ...state,
        ...flags,
      };
    }

    default:
      return state;
  }
};

export default BookingCalendar;
